import { WarningOutlined } from '@ant-design/icons'
import type { ViewFieldsFragment } from '@salescore/client-api'
import { Posthog, POSTHOG_EVENTS } from '@salescore/client-base'
import { canViewCompileError, useMe } from '@salescore/client-common'
import type {
  CompiledFormViewConfig,
  CompiledKpiPivotViewConfig,
  CompiledKpiViewConfig,
  CompiledSheetViewConfig,
} from '@salescore/core'
import { Badge, Button } from 'antd'
import { type ReactElement, useEffect } from 'react'
import { useRecoilState } from 'recoil'

import { errorsAtom } from '../../../recoil/records/atoms'
import { useRefetchAggregationQueryResult } from '../../../recoil/records/mutations/useRefetchAggregationQueryResult'

export const CompileErrorsButton = ({
  onClick,
  compiledConfig,
  view,
}: {
  onClick: () => void
  compiledConfig: CompiledSheetViewConfig | CompiledKpiViewConfig | CompiledKpiPivotViewConfig | CompiledFormViewConfig
  view: ViewFieldsFragment
}): ReactElement => {
  const [queryErrors] = useRecoilState(errorsAtom)
  const { aggregationQueryErrors } = useRefetchAggregationQueryResult(compiledConfig, view)
  const errors = [...compiledConfig.context.logs.showErrors(), ...queryErrors, ...aggregationQueryErrors] // ここを変更したらCompileLogsModal側も変更すること
  const warns = compiledConfig.context.logs.showWarns()
  const me = useMe()

  useEffect(() => {
    // eslint-disable-next-line array-callback-return,unicorn/no-unused-builtin-method-return,sonarjs/array-callback-without-return,sonarjs/no-ignored-return
    errors.map((error) => {
      Posthog.track(POSTHOG_EVENTS.view_compile_header_error, { message: error })
    })
    // eslint-disable-next-line array-callback-return,unicorn/no-unused-builtin-method-return,sonarjs/array-callback-without-return,sonarjs/no-ignored-return
    warns.map((warn) => {
      Posthog.track(POSTHOG_EVENTS.view_compile_header_warning, { message: warn })
    })
  }, [])

  if (errors.length > 0) {
    return (
      <Badge count={errors.length} overflowCount={999} offset={[-3, 3]}>
        <Button type="default" onClick={onClick} danger icon={<WarningOutlined />} />
      </Badge>
    )
  }

  if (warns.length > 0 && canViewCompileError(me)) {
    // ユーザー向けのわかりやすい警告表示にできていないので、一旦表示しないという話になった
    return (
      <Badge count={warns.length} overflowCount={999} offset={[-3, 3]} color="yellow">
        <Button
          type="default"
          onClick={onClick}
          icon={<WarningOutlined />}
          className="border-yellow-400 text-yellow-500"
        />
      </Badge>
    )
  }

  return <></>
}
